
(() => {
  const threshold = 10000; // $100 NZD in cents
  let updating = false;
  let lastTotal = null;

  async function updateShippingProgress() {
    const widgets = document.querySelectorAll('.kean-shipping-progress');
    if (!widgets.length || updating) return;

    updating = true;

    try {
      const response = await fetch(
        `${window.Shopify?.routes?.root || '/'}cart.js`,
        { credentials: 'same-origin', cache: 'no-store' }
      );
      if (!response.ok) return;

      const cart = await response.json();
      const total = cart.total_price;

      if (total === lastTotal) return;
      lastTotal = total;

      const remaining = Math.max(0, threshold - total);
      const progress = Math.min(100, (total / threshold) * 100);

      const formatMoney = cents =>
        new Intl.NumberFormat('en-NZ', {
          style: 'currency',
          currency: 'NZD'
        }).format(cents / 100);

      widgets.forEach(widget => {
        const message = widget.querySelector('.kean-shipping-message');
        const bar = widget.querySelector('.kean-shipping-bar');

        if (message) {
          message.textContent = remaining > 0
            ? `You're ${formatMoney(remaining)} away from FREE shipping!`
            : "You've unlocked FREE shipping! 🎉";
        }

        if (bar) bar.style.width = `${progress}%`;
        
const shippingRate = widget.closest('.cart--form')?.querySelector('.kean-shipping-rate');
if (shippingRate) {
  shippingRate.textContent = remaining > 0
    ? 'Tax included | NZ shipping $8.80, FREE over $100'
    : 'Tax included | FREE NZ shipping';
}

      });
    } catch (error) {
      console.warn('KEAN shipping progress:', error);
    } finally {
      updating = false;
    }
  }

  const observer = new MutationObserver(() => {
    updateShippingProgress();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', updateShippingProgress);
  updateShippingProgress();
})();
